<template>
  <!-- org_welcome moved to LanderContactDetails -->
  <div></div>
</template>

<script setup>
defineProps({
  config: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="less">
#lander_welcome {
  margin-bottom: 2rem;

  p {
    margin-bottom: 1rem;
  }
}
</style>